<template>
    <div class="box">
        <div class="text1">提高旺旺响应率至<span>80%以上</span></div>
        <div class="text1">平均提升<span>54.6%</span>平台搜索权重</div>
        <div class="text1">有效提升新客询单转化</div>
        <div class="text1">加快打标“响应快”“星商家”速度</div>
        <div class="text3">
            <img :src="require('@/assets/WelfareFebruary6.png')" alt="">
            <div>无限量微信消息</div>
            <div>1200条短信+300分钟通话</div>
        </div>
        <div class="button_box">
            <div @click="show_popup" class="button">51元立即提升</div>
            <div class="text6">原价150元/三个月</div>
        </div>
        <Popup v-model="popup_show"
        position="top"
        overlay-class="popup_box"
        :close-on-click-overlay="false"
        :lock-scroll="true"
        :lazy-render="false">
            <img class="WXTExtension_popup" :src="popup_img">
        </Popup>
    </div>
</template>
<script>
import { Popup } from 'vant';
export default {
    components:{
        Popup,
    },
    data(){
        let popup_img
        if(this.$config.SystemOS=='IOS'){
            popup_img = this.$OSSBaseUrl +'renew_tips_ios.png';
        }else{
            popup_img = this.$OSSBaseUrl + 'renew_tips_android.png';
        }
        return{
            popup_img,
            popup_show:true,
            record_data:{
                page_from:'main_page',
                page_name:'WelfareFebruary/MarkPage',
                page_time:'0.00',
                receiver_id: '',
                page_param:{dayhour:this.$route.query.dayhour,},
            },
        }
    },
    mounted(){
        this.$store.dispatch('Public/inH5Record', this.record_data)
    },
    methods:{
        show_popup(){
            let data = JSON.parse(JSON.stringify(this.record_data))
            data.btn_name = 'WelfareFebruary/MarkPage'
            this.$store.dispatch('Public/inH5Record', data)
            this.popup_show = true
        }
    },
}
</script>
<style lang="scss" scoped>
    @import 'MarkPage.scss';
</style>